var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Adjust Spam Threshold Score ")]),
      _c(
        "gg-card-text",
        [
          _vm.$attrs.pending
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center py-10",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          size: "70"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm._v(" Current score is "),
                      _c("b", [_vm._v(_vm._s(_vm.scoreText))])
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c("gg-select", {
                        attrs: {
                          items: _vm.score_items,
                          "item-text": "label",
                          "item-value": "value",
                          name: "scoreSelect"
                        },
                        model: {
                          value: _vm.scoreSelect,
                          callback: function callback($$v) {
                            _vm.scoreSelect = $$v
                          },
                          expression: "scoreSelect"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isCustomScore
                    ? _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min_value:1|max_value:50",
                                expression:
                                  "'required|min_value:1|max_value:50'"
                              }
                            ],
                            attrs: {
                              name: "Score",
                              "data-vv-as": "Spam Threshold Score",
                              "error-messages": _vm.errors.collect("Score")
                            },
                            model: {
                              value: _vm.scoreValue,
                              callback: function callback($$v) {
                                _vm.scoreValue = $$v
                              },
                              expression: "scoreValue"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            primary: "",
                            loading: _vm.pending
                          },
                          on: {
                            click: _vm.updateScore
                          }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }